import { render } from "./DeleteProfile.vue?vue&type=template&id=1d524438"
import script from "./DeleteProfile.vue?vue&type=script&lang=js"
export * from "./DeleteProfile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/TheIdFactory/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__